import icon_nolocation from "./img/location_on.svg";
import icon_letsgo from "./img/notifications/fire-animated-2.gif";
import icon_done from "./img/notifications/party.gif";
import icon_bell from "./img/notifications/bell.gif";

const notificationtemplates = {
  nolocation: {
    icon: icon_nolocation,
    // headline: {
    //   de: "Kein Standort",
    //   en: "No Location",
    //   it: ""
    // },
    text: {
      de: "Aktiviere deinen Standort, um das Spiel zu starten",
      en: "Activate your location to play the game",
      it: "Attiva la tua posizione per giocare"
    },
    /*button: {
      de: "Funktioniert nicht?",
      en: "Having trouble?",
      it: "Problemi?"
    },*/
    primarybutton: {
      de: "Standort einschalten",
      en: "Enable location",
      it: "Attiva la posizione"
    },
    dismissable: false  
  },
  letsgo: {
    icon: icon_letsgo,
    headline: {
      de: "Los geht's!",
      en: "Let's go!",
      it: "Andiamo!"
    },
    text: {
      de: "Die erste Station wartet auf dich!",
      en: "The first station awaits you!",
      it: "La prima stazione ti aspetta!"
    },
    dismissable: true  
  },
  laststation: {
    icon: icon_done,
    headline: {
      de: "Gleich geschafft!",
      en: "Almost there!",
      it: "Quasi arrivato!"
    },
    text: {
      de: "Nur noch eine Station...",
      en: "Only one station left...",
      it: "Solo una stazione rimasta..."
    },
    dismissable: true  
  },
  done: {
    icon: icon_done,
    headline: {
      de: "Abzeichen freigeschaltet!",
      en: "Badge unlocked!",
      it: "Distintivo sbloccato!"
    },
    text: {
      de: "Gehe zum Abzeichen, um es einzusammeln.",
      en: "Go close to the badge to collect it.",
      it: "Vai al distintivo per raccoglierlo."
    },
    dismissable: true  
  },
  soundon: {
    icon: icon_bell,
    headline: {
      de: "Sound ist an",
      en: "Sound is on",
      it: "L'audio è attivo"
    },
    text: {
      de: "Du hörst was, wenn du die Station erreichst. Lasse dein Display dafür an.",
      en: "You hear a sound when you reach the station. Keep you screen on for that.",
      it: "Sentirai un suono quando raggiungi la stazione. Tieni lo schermo acceso."
    },
    dismissable: true  
  },
  lowlocationaccuracy: {
    icon: icon_nolocation,
    headline: {
      de: "Standort ungenau",
      en: "Location is approximate",
      it: "Posizione imprecisa"
    },
    text: {
      de: "Aktiviere den genauen Standort, damit nahe Stationen zuverlässig freigeschaltet werden.",
      en: "Enable precise location so nearby stations unlock reliably.",
      it: "Attiva la posizione precisa per sbloccare le stazioni vicine in modo affidabile."
    },
    button: {
      de: "Hilfe",
      en: "Help",
      it: "Aiuto"
    },
    dismissable: true
  },

};

export default notificationtemplates;
